export const PATIENT_STATUS_MAPPED = new Map([
  [1, 'Active'],
  [0, 'In-active']
])
